// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"table-add"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 7H3V21H21V7Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 3H3V7H21V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3V21H21V3M3 3H21M3 3V7H21V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 11V14M12 14V17M12 14H9M12 14H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TableAddIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table-add',
    ref,
    icon: element,
  },
));

TableAddIcon.displayName = 'TableAddIcon';

export default TableAddIcon;
